export default __webpack_public_path__ + "051e2b20a92849b6c657344d47eb1efd.jpg";